require ('slick-carousel')

class slider {
  _setDots() {
    let $sliderContainer = document.querySelector('.home-slider'),
        $dots = document.querySelector('.home-slider--dots')

    if($sliderContainer.offsetWidth > 1200) {
      let r = ($sliderContainer.offsetWidth - 1200) / 2
      $dots.style.right = r + 'px'
    } else {
      $dots.style.right = ($sliderContainer.offsetWidth >= 768) ? '0px' : 'auto'
      $dots.style.left = ($sliderContainer.offsetWidth >= 768) ? 'auto' : '10px'
    }
  }

  _moveDash() {
    let $active = document.querySelector('.slick-dots .slick-active'),
        $dash   = document.querySelector('.home-slider--dots .dash'),
        w = $active.offsetWidth,
        l = $active.offsetLeft

    $dash.style.width = w + 'px'
    $dash.style.left = l + 10 + 'px'
  }

  home() {
    const self = this
    let $slider = $('.home-slider'),
        resizeTimer


    $slider.slick({
      appendDots: '.home-slider--dots',
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      dots: true,
      pauseOnHover: false,
      pauseOnDotsHover: true,
      customPaging: function(slick, index) {
        let str = '<span>'
        str += ( index < 10 ) ? '0' + (index + 1) : index + 1
        str += '</span>'
        return str
      }
    })

    this._setDots()

    this._moveDash()

    $slider.on('afterChange', function() {
      self._moveDash()
    })

    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(function() {
        self._setDots()
      }, 250)
    })
  }

  services() {
    let $slider = $('.services-carousel')
    $slider.slick({
      appendArrows: '.services-carousel--arrows',
      slidesToShow: 4,
      infinite: false,
      prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-caret-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="fas fa-caret-right"></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    })
  }
}
export default slider
